// extracted by mini-css-extract-plugin
export default {"shape":"Shape_shape__9BUI2","content":"Shape_content__9A0oH"};